import { styled } from '@mui/system'

export const Root = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
`
export const StickyWrapper = styled('div')`
	width: 100%;
	height: 100%;
	position: sticky;
	top: var(--header-sticky-top, 0);
	transition: top 0.2s ease-out;
`
